import Caller from '@/classes/caller.js'

class NetworkUtils {
	
	constructor(){
		this.caller = new Caller()
	}

	setRouter (route) {
		this.route = route
	}

	getShowId () {
		return this.route.query.show_id == undefined ? '' : this.route.query.show_id
	}

	getOffers(params){
		return this.caller.request({ method: 'get', url: '/offers/' + this.getShowId(), data: params })
	}

	// Always hits the index action. Unlike getOffers, it never appends show_id,
	// so the response is guaranteed to be a list and never a single record.
	getOffersList(params){
		return this.caller.request({ method: 'get', url: '/offers/', data: params })
	}

	getOffer(offer_id){
		return this.caller.request({ method: 'get', url: '/offers/' + offer_id })
	}

	getCompanies(){
		return this.caller.request({ method: 'get', url: '/companies/' + this.getShowId() })
	}

	getCompany(company_id){
		return this.caller.request({ method: 'get', url: '/companies/' + company_id })
	}

	getStats(params){
		return this.caller.request({ method: 'get', url: '/stats/', data: params })
	}

	getStat(stat_id){
		return this.caller.request({ method: 'get', url: '/stats/' + stat_id })
	}

	searchCompany(search_term){
		return this.caller.request({ method: 'get', url: '/companies/', data: { company_name: search_term } })
	}

	getRecruiterFees(params){
		return this.caller.request({ method: 'get', url: '/recruiter_fees/', data: params })
	}

	getRecruiterPayments(params){
		return this.caller.request({ method: 'get', url: '/recruiter_payments/', data: params })
	}

	getRecruiterPayment(recruiter_payment_id){
		return this.caller.request({ method: 'get', url: '/recruiter_payments/' + recruiter_payment_id })
	}

	getRecruiterFee(recruiter_fee_id){
		return this.caller.request({ method: 'get', url: '/recruiter_fees/' + recruiter_fee_id })
	}

	getExpenses(params){
		return this.caller.request({ method: 'get', url: '/expenses/', data: params })
	}

	getExpense(expense_id){
		return this.caller.request({ method: 'get', url: '/expenses/' + expense_id })
	}

	getListOfRecruiterNames(){
		return this.caller.request({ method: 'get', url: '/recruiters/' })
	}

	getFile (params) {
		return this.caller.request({ method: 'get', url: '/files/1/', data: { ...params, responseType: 'blob' } })
	}

	getFiles(params){
		return this.caller.request({ method: 'get', url: '/files/', data: params })
	}

	updateCompany(params){
		return this.caller.request({ method: 'put', url: '/companies/' + params.id, data: params })
	}

	updateOffer(params){
		return this.caller.request({ method: 'put', url: '/offers/' + params.id, data: params })
	}

	updateAccountingCompany(params){
		return this.caller.request({ method: 'put', url: '/companies/' + params.id, data: params })
	}

	updateRecruiterPayment(params){
		return this.caller.request({ method: 'put', url: `/recruiter_fees/${params.id}`, data: params })
	}

	deleteRecruiterPayment(params){
		return this.caller.request({ method: 'delete', url: `/recruiter_payments/${params.id}`, data: params })
	}

	deleteOffer(params){
		return this.caller.request({ method: 'delete', url: '/offers/' + params.id, data: params })
	}

	deleteRecruiterFee(params){
		return this.caller.request({ method: 'delete', url: '/recruiter_fees/' + params.id, data: params })
	}

	deleteExpense(params){
		return this.caller.request({ method: 'delete', url: '/expenses/' + params.id, data: params })
	}

	generateDocument(params){
		return this.caller.request({ method: 'post', url: '/generate_document/', data: params })
	}

  	uploadFile (form_data) {
    	return this.caller.request({ method: 'post', url: '/files/', data: form_data })
  	}

	deleteFile (params) {
		return this.caller.request({ method: 'delete', url: '/files/1', data: params })
	}

	updateFile (params) {
		return this.caller.request({ method: 'put', url: '/files/1', data: params })
	}

	login(params){
		return this.caller.request({ method: 'post', url: '/authenticate/', data: params })
	}

	search(params){
		return this.caller.request({ method: 'get', url: '/search/', params })
	}

	getUser(params){
		return this.caller.request({ method: 'get', url: '/users/1' })
	}

}

export default NetworkUtils